import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { ApiService } from 'api/services/ApiService';

/**
 * Hook to fetch company measurement date by attio_valuation_id from URL params or provided value
 * This is useful when the global state doesn't have the measurement date loaded
 * but we have the attio_valuation_id from the URL or from props
 */
export const useCompanyMeasurementDateByAttioValuationId = (valuationIdOverride?: string) => {
  const { valuationId: valuationIdFromParams } = useParams<{ valuationId: string }>();
  const valuationId = valuationIdOverride || valuationIdFromParams;
  
  return useQuery({
    queryKey: ['company-measurement-date-by-attio-valuation-id', valuationId],
    queryFn: async () => {
      if (!valuationId) {
        throw new Error('Valuation ID is required');
      }
      
      // Use the API endpoint to get company measurement date by attio_valuation_id
      return ApiService.apiCompanyMeasurementDatesRead(valuationId);
    },
    enabled: !!valuationId,
    retry: false,
    refetchOnWindowFocus: false,
  });
};
